// extracted by mini-css-extract-plugin
export var chevronIcon = "_af-2";
export var teamName = "_af-1";
export var teamSwitcherButton = "_af-0";